module.exports = __webpack_public_path__ + "img/hub.73de4ae0.svg";